import { Tooltip } from "@mui/material";
import classNames from "classnames";
import React from "react";
import CheckSvg from "../../../assets/svgs/CheckSvg";
import { Icon } from "@virtuslab/tetrisly-icons";
import Lock from "../../../assets/svgs/Lock";
import Unlock from "../../../assets/svgs/Unlock";

export const formatTime = (time) => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);

  if (hours > 0) {
    return `${hours} ${hours < 2 ? "hour" : "hours"} ${minutes} ${
      minutes < 2 ? "minute" : "minutes"
    }`;
  }

  return `${minutes} ${minutes < 2 ? "minute" : "minutes"}`;
};

const AppointmentCard = ({
  appointment,
  index,
  editable,
  handleStatusModal,
  handleLockModal,
  setAppointmentToChangeStatus,
  setAppointmentToLock,
  updatedAppointments,
}) => {
  return (
    <button
      disabled={!appointment.proposedPatient}
      className={classNames(
        "flex flex-col w-full gap-4 p-3 rounded-md shadow-custom border ",
        editable && "cursor-pointer",
        appointment.proposedPatient
          ? "bg-subtlegreen border-primaryblack"
          : "bg-white border-primarygrayborder"
      )}
    >
      <div className="flex relative w-full">
        <div className="flex flex-col gap-4 w-full">
          <div className="flex flex-row gap-2 justify-between w-full">
            <div className="flex flex-row gap-4 items-center">
              <div
                className={classNames(
                  "flex items-center justify-center rounded-full text-sm font-semibold w-10 h-10",
                  appointment.status === "UNLOCKED"
                    ? "bg-[#F2C94C] text-white"
                    : appointment.status === "LOCKED"
                    ? "bg-[#3062D4] text-white"
                    : appointment.status === "PUBLISHED"
                    ? "bg-[#6FCF97] text-white"
                    : "bg-[#fff] text-primaryblack"
                )}
              >
                {index + 1}
              </div>
              <div className="flex flex-col gap-0 items-start">
                <span className="m-0 text-left text-xl font-bold text-primaryblack w-[490px] truncate">
                  {`${appointment.patient?.name} | ${
                    appointment.location?.name !== null
                      ? appointment.location?.name
                      : "Private Residence"
                  }`}
                </span>
                <span className="m-0 text-base font-normal text-left text-primarytextgrey">
                  {index === 0
                    ? `${Math.trunc(
                        Number(appointment.distanceFromHome)?.toFixed(0) ?? 0
                      )} miles from home`
                    : `${Math.trunc(
                        Number(appointment.distance)?.toFixed(0) ?? 0
                      )} miles from previous appointment`}
                  {index === updatedAppointments.length - 1
                    ? ` and ${Math.trunc(
                        Number(appointment.distanceFromHome)?.toFixed(0) ?? 0
                      )} miles from home`
                    : ``}
                  {appointment?.appointmentType?.duration &&
                    ` | ${appointment?.appointmentType?.duration}-min visit`}
                </span>
                {appointment?.appointmentType?.isTelehealth && (
                  <span className="m-0 text-base font-normal text-left text-primarytextgrey">
                    {formatTime(appointment?.duration ?? 0)} from home
                  </span>
                )}
              </div>
            </div>
            {appointment.status === "PUBLISHED" && (
              <Tooltip title="Published to Athena">
                <div className="flex justify-center items-center w-10 h-10 bg-gray-50 rounded-lg">
                  <CheckSvg color={"#6FCF97"} />
                </div>
              </Tooltip>
            )}
          </div>
          <div className="flex justify-evenly w-full">
            <button
              disabled={true}
              className={classNames(
                "text-sm m-0 py-1 px-2 border-[1px] bg-primarylightgrey font-semibold rounded-lg",
                appointment.proposedPatient
                  ? "text-primaryblack border-primaryblack"
                  : "text-primarytextgrey border-primarylightgrey"
              )}
            >
              {appointment.appointmentType.name}
            </button>
            <button
              // disabled={true}
              className={classNames(
                "text-sm m-0 py-1 px-2 bg-white font-semibold rounded-lg flex items-center gap-1",
                appointment.proposedPatient
                  ? "text-primaryblack border-[1px] border-primaryblack"
                  : appointment.visitStatus === "COMPLETED"
                  ? "text-primarygreen border-[1px] border-primarygreen"
                  : appointment.visitStatus === "SCHEDULED" ||
                    appointment.visitStatus == null
                  ? "text-primaryyellow border-[1px] border-primaryyellow"
                  : appointment.visitStatus === "CANCELLED"
                  ? "text-primaryred border-[1px] border-primaryred"
                  : "text-primaryblue border-[1px] border-primaryblue"
              )}
              onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setAppointmentToChangeStatus(appointment);
                handleStatusModal(appointment.visitStatus);
              }}
            >
              {appointment.visitStatus === "SCHEDULED" ||
              appointment.visitStatus == null ? (
                <Icon
                  name="20-hourglass"
                  color={appointment.proposedPatient ? "#000" : "#F2C94C"}
                />
              ) : appointment.visitStatus === "CONFIRMED" ? (
                <Icon name="20-calendar-check" color={"#3062D4"} />
              ) : appointment.visitStatus === "CANCELLED" ? (
                <Icon name="20-calendar-close" color={"#eb5757"} />
              ) : (
                <CheckSvg color={"#27AE60"} />
              )}
              {appointment.visitStatus === "SCHEDULED" ||
              appointment.visitStatus == null
                ? "Pending"
                : appointment.visitStatus === "CONFIRMED"
                ? "Confirmed"
                : appointment.visitStatus === "CANCELLED"
                ? "Cancelled"
                : "Completed"}
            </button>
            <button
              // disabled={true}
              className={classNames(
                "text-sm m-0 py-1 px-2 bg-white font-semibold rounded-lg flex items-center gap-1",
                appointment.proposedPatient
                  ? "text-primaryblack border-[1px] border-primaryblack"
                  : appointment.status === "PUBLISHED"
                  ? "text-primarygreen border-[1px] border-primarygreen"
                  : appointment.status === "UNLOCKED"
                  ? "text-primaryyellow border-[1px] border-primaryyellow"
                  : "text-primaryblue border-[1px] border-primaryblue"
              )}
              onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setAppointmentToLock(appointment);
                handleLockModal();
              }}
            >
              {appointment.status === "UNLOCKED" ? (
                <Unlock
                  color={appointment.proposedPatient ? "#000" : "#F2C94C"}
                />
              ) : appointment.status === "LOCKED" ? (
                <Lock color={"#3062D4"} />
              ) : (
                <CheckSvg color={"#27AE60"} />
              )}
              {appointment.status === "PUBLISHED"
                ? "Published"
                : appointment.status === "UNLOCKED"
                ? "Unlocked"
                : "Locked"}
            </button>
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="flex justify-end">
          <p className="m-0">{appointment?.timeslot}</p>
        </div>
      </div>
    </button>
  );
};

export default AppointmentCard;
